export default __webpack_public_path__ + "static/media/PostgreSQL-Logo.wine.e407ebb1.svg";